import {
  isTaskTreeCycleError,
  isTaskTreeDepthExceededError,
  isTaskTreeMoveBlockedError,
  isTaskTreeSizeExceededError,
} from '../graphqlErrors';

export const TASK_TREE_ERROR_KEY = {
  MOVE_BLOCKED: 'doBox.taskTree.errors.moveBlocked',
  CYCLE: 'doBox.taskTree.errors.cycle',
  DEPTH_EXCEEDED: 'doBox.taskTree.errors.depthExceeded',
  SIZE_EXCEEDED: 'doBox.taskTree.errors.sizeExceeded',
  GENERIC: 'doBox.taskTree.errors.generic',
} as const;

const ERROR_KEY_BY_PREDICATE: ReadonlyArray<
  readonly [(err: unknown) => boolean, string]
> = [
  [isTaskTreeMoveBlockedError, TASK_TREE_ERROR_KEY.MOVE_BLOCKED],
  [isTaskTreeCycleError, TASK_TREE_ERROR_KEY.CYCLE],
  [isTaskTreeDepthExceededError, TASK_TREE_ERROR_KEY.DEPTH_EXCEEDED],
  [isTaskTreeSizeExceededError, TASK_TREE_ERROR_KEY.SIZE_EXCEEDED],
];

export function resolveTaskTreeErrorKey(err: unknown): string {
  const match = ERROR_KEY_BY_PREDICATE.find(([isMatch]) => isMatch(err));
  return match ? match[1] : TASK_TREE_ERROR_KEY.GENERIC;
}
